module.exports = __webpack_public_path__ + "img/s1-10.4e31822b.jpeg";